// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Vv","styleWarning":"e_Wv"};